import React from "react";
import "./FashionSpotlight.css";

const FashionSpotlight = () => {
	return (
		<section className="stats-section">
			<div className="container">
				<div className="divonette-container">
					<h2 className="divonette-title">Moda za sve generacije</h2>
					<p className="divonette-text">
						Otkrijte raznovrsne kolekcije odjeće i modnih kombinacija. Nudimo
						kombinacije za svakodnevne aktivnosti, poslovne dane ili posebne
						prilike. U našem asortimanu možete pronaći sve od udobnih majica i
						hlača do elegantnih kombinacija za svečane događaje.
					</p>
				</div>
			</div>
		</section>
	);
};

export default FashionSpotlight;
